export enum AddHearingStatus {
  BASE = 'BASE',
  ENTER_PHONE_NUMBER = 'ENTER_PHONE_NUMBER',
  CONNECTING = 'CONNECTING',
}
